var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: "12" } },
        [
          (
            _vm.loading !== null
              ? _vm.loading
              : _vm.$store.state.accounts.LoaderMe ||
                _vm.$store.state.purchases.retrieveLoader
          )
            ? _c("skeleton-list")
            : [
                !_vm.$helpers.hasPermission(["view_purchase"])
                  ? _c("PermissionDenied")
                  : [
                      !_vm.purchasesList.length ||
                      (!_vm.routeList.includes(_vm.$route.name) &&
                        !Object.keys(_vm.$route?.query).length)
                        ? _c("v-empty-state", {
                            class: {
                              "pt-6 pb-0": _vm.routeList.includes(
                                _vm.$route.name
                              ),
                            },
                            attrs: {
                              type: "documents",
                              id: "documentos",
                              customClass: _vm.routeList.includes(
                                _vm.$route.name
                              )
                                ? "mt-0 pb-2"
                                : "mt-0",
                              isFree: _vm.routeList.includes(_vm.$route.name),
                              title: "No existen documentos para mostrar",
                              height: _vm.routeList.includes(_vm.$route.name)
                                ? 100
                                : 280,
                              minHeight: _vm.routeList.includes(_vm.$route.name)
                                ? "auto"
                                : "calc(100vh - 300px)",
                              hiddenDescription: _vm.hiddenBtnEmpty,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "actions",
                                  fn: function () {
                                    return [
                                      !_vm.routeList.includes(
                                        _vm.$route.name
                                      ) && _vm.hiddenBtnEmpty
                                        ? [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "grey-900",
                                                  ripple: false,
                                                  width: 153,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$emit(
                                                      "activeBtnFilter"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "mr-2" },
                                                  [_vm._v("mdi-filter-plus")]
                                                ),
                                                _vm._v("Filtrar"),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "ml-2",
                                                attrs: {
                                                  outlined: "",
                                                  ripple: false,
                                                  width: "153",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.latestRecords()
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "mr-2" },
                                                  [
                                                    _vm._v(
                                                      "mdi-text-search-variant"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v("Últimos registros"),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1633689393
                            ),
                          })
                        : [
                            _c("v-data-table", {
                              class: [
                                {
                                  "table-not-rounded": [
                                    "SupplierRetrieveUpdate",
                                  ].includes(_vm.$route.name),
                                },
                                {
                                  "fixed-table":
                                    _vm.$store.state.base
                                      .isExpandNavigationDrawer,
                                },
                              ],
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                headers: _vm.currentHeader,
                                items: _vm.purchasesList,
                                "items-per-page":
                                  _vm.pageSize || _vm.pagination,
                                "hide-default-header": "",
                                "disable-sort": "",
                                "mobile-breakpoint": "",
                                "hide-default-footer": "",
                                "item-key": "id",
                                "show-select": !_vm.routeList.includes(
                                  _vm.$route.name
                                ),
                                "checkbox-color": "green-500",
                                "fixed-header": !_vm.routeList.includes(
                                  _vm.$route.name
                                ),
                                height: _vm.heightTable,
                              },
                              on: {
                                "click:row": (purchasesList) => {
                                  _vm.goTo(purchasesList.id)
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function ({ props: { headers } }) {
                                      return [
                                        _c("VTableHeaders", {
                                          attrs: {
                                            headers: headers,
                                            resetCheckbox: _vm.resetCheckbox,
                                          },
                                          on: {
                                            sort: _vm.setSort,
                                            toggleAll: _vm.toggleAll,
                                            isSelected: function ($event) {
                                              _vm.isSelected = $event
                                            },
                                            toggleDropdown: function ($event) {
                                              _vm.toggleDropdown = $event
                                            },
                                          },
                                        }),
                                        _c("v-divider", {
                                          staticStyle: {
                                            position: "absolute",
                                            "margin-top": "-6px",
                                            "margin-left": "-5px",
                                            "z-index": "2",
                                            "min-width": "100%",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.supplier_name`,
                                    fn: function ({ item }) {
                                      return [
                                        item.supplier_name.length
                                          ? [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "d-inline-block text-truncate",
                                                  class:
                                                    _vm.$route.name ===
                                                    "SupplierRetrieveUpdate"
                                                      ? "body-2"
                                                      : "body-1 mb-n2",
                                                  staticStyle: {
                                                    "max-width": "90%",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.supplier_name)
                                                  ),
                                                ]
                                              ),
                                              item.tax_id
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "caption grey-300--text d-block",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("generals.RUT")
                                                        ) +
                                                          " " +
                                                          _vm._s(item.tax_id)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 text--disabled font-italic",
                                              },
                                              [_vm._v("Sin especificar")]
                                            ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.type`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-decoration-none grey-500--text",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("nameDocumentsType")(
                                                  item.type
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.number`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-center justify-end",
                                          },
                                          [
                                            item.assignment_agency_status
                                              ? _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      color: "grey-background",
                                                      right: "",
                                                      transition:
                                                        "scale-transition",
                                                      "max-width": "250",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "v-avatar",
                                                                _vm._g(
                                                                  {
                                                                    staticClass:
                                                                      "mr-2",
                                                                    attrs: {
                                                                      color:
                                                                        "grey-900",
                                                                      size: "24",
                                                                    },
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "white",
                                                                        size: "12",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-file-arrow-left-right"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "px-3 py-2",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "d-block font-weight-bold",
                                                          },
                                                          [_vm._v("Cedido")]
                                                        ),
                                                        item.assignee_tax_id
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "d-block",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "generals.RUT"
                                                                    )
                                                                  ) +
                                                                    ": " +
                                                                    _vm._s(
                                                                      item.assignee_tax_id
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        item.assignee_name
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "d-block",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.assignee_name
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              { staticClass: "body-1" },
                                              [_vm._v(_vm._s(item.number))]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.date`,
                                    fn: function ({ item }) {
                                      return [
                                        _c("span", { staticClass: "body-1" }, [
                                          _vm._v(
                                            _vm._s(_vm._f("date")(item.date))
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.rec_status`,
                                    fn: function ({ item }) {
                                      return [
                                        _c("chip-status", {
                                          staticStyle: {
                                            "white-space": "nowrap !important",
                                          },
                                          attrs: {
                                            type: "purchases",
                                            status: item.rec_status
                                              ? item.rec_status
                                              : "CRE",
                                            detail:
                                              item?.rec_status_info ?? null,
                                            isTooltip: true,
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.status`,
                                    fn: function ({ item }) {
                                      return [
                                        item.status
                                          ? _c("chip-status", {
                                              staticStyle: {
                                                "white-space":
                                                  "nowrap !important",
                                              },
                                              attrs: {
                                                type: "documents",
                                                status: item.status
                                                  ? item.status
                                                  : "CRE",
                                                detail: ["SNT", "FAI"].includes(
                                                  item.status
                                                )
                                                  ? `Última fecha de actualización: <br> ${_vm.updatedDate(
                                                      item.updated
                                                    )}`
                                                  : null,
                                                isActivePopover: [
                                                  "SNT",
                                                  "FAI",
                                                ].includes(item.status),
                                                isTooltip: true,
                                              },
                                            })
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text--disabled font-italic",
                                              },
                                              [_vm._v("Sin especificar")]
                                            ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.due_date`,
                                    fn: function ({ item }) {
                                      return [
                                        item.due_date
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("date")(item.due_date)
                                                )
                                              ),
                                            ])
                                          : _c("span", [_vm._v("---")]),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.created`,
                                    fn: function ({ item }) {
                                      return [
                                        _c("span", { staticClass: "body-1" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("dateTime")(item.created)
                                            )
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.validation_date`,
                                    fn: function ({ item }) {
                                      return [
                                        item.validation_date
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("dateTime")(
                                                    item.validation_date
                                                  )
                                                )
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.assignee_info`,
                                    fn: function ({ item }) {
                                      return [
                                        item.assignee_name
                                          ? [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-1 mb-n2 d-inline-block text-truncate",
                                                  staticStyle: {
                                                    "max-width": "90%",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.assignee_name)
                                                  ),
                                                ]
                                              ),
                                              item.assignee_tax_id
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "caption grey-300--text d-block",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("generals.RUT")
                                                        ) +
                                                          " " +
                                                          _vm._s(
                                                            item.assignee_tax_id
                                                          )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _c(
                                              "span",
                                              { staticClass: "text--disabled" },
                                              [_vm._v("---")]
                                            ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.amount_total`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "body-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$fmt.currency(
                                                      item.currency ||
                                                        _vm.$store?.state?.auth
                                                          ?.account?.currency,
                                                      item.amount_total
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.actions`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              "close-on-click": "",
                                              "close-on-content-click": "",
                                              "offset-y": "",
                                              left: "",
                                              "nudge-bottom": 10,
                                              "nudge-left": 10,
                                              transition: "slide-y-transition",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "mr-n4",
                                                              attrs: {
                                                                text: "",
                                                                "x-small": "",
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "grey-700",
                                                                size: "24",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-dots-vertical"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "v-list",
                                              { staticClass: "pa-0" },
                                              [
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    staticClass: "px-3",
                                                    attrs: { ripple: false },
                                                    on: {
                                                      click: function ($event) {
                                                        ;(_vm.current = item),
                                                          _vm.renderDocument2(
                                                            "purchases",
                                                            "rec-docs",
                                                            "pdf",
                                                            item.id
                                                          ),
                                                          (_vm.resetPDF += 1)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "body-1 grey-500--text d-flex align-center",
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              color: "grey-700",
                                                              small: "",
                                                              left: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-text-box"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v("Ver PDF"),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    staticClass: "px-3",
                                                    attrs: { ripple: false },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.downloadFile2(
                                                          "purchases",
                                                          `${item.type}_N${item.number}`,
                                                          "rec-docs",
                                                          "xml",
                                                          item.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "body-1 grey-500--text d-flex align-center",
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              color: "grey-500",
                                                              small: "",
                                                              left: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-code-braces-box"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v("Descargar XML"),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.selected,
                                callback: function ($$v) {
                                  _vm.selected = $$v
                                },
                                expression: "selected",
                              },
                            }),
                            _vm.showPagination || _vm.showAll
                              ? _c("VMainPagination", {
                                  attrs: {
                                    titleShowAll: "Ver todos los documentos",
                                    count: _vm.count,
                                    pageSize: _vm.pageSize,
                                    redirect: "purchasesList",
                                  },
                                })
                              : _vm._e(),
                          ],
                    ],
              ],
          _c(
            "v-dialog",
            {
              attrs: {
                width: "700",
                persistent: "",
                scrollable: "",
                "no-click-animation": "",
                "overlay-color": "grey-500",
              },
              model: {
                value: _vm.modalRender,
                callback: function ($$v) {
                  _vm.modalRender = $$v
                },
                expression: "modalRender",
              },
            },
            [
              _c("render-pdf", {
                key: _vm.resetPDF,
                attrs: {
                  basicRender: true,
                  documentType: _vm._f("nameDocumentsType")(_vm.current.type),
                  number: _vm.current.number,
                  loaderRender: _vm.loaderRender,
                  renderUrl: _vm.renderUrl,
                  showFormat: false,
                },
                on: {
                  close: function ($event) {
                    _vm.modalRender = false
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }